export default __webpack_public_path__ + "static/deckCreek-c297b0b076cf37ccaed1a00a21bcdf32.jpg";